import { render } from "./ModalAlert.vue?vue&type=template&id=a07111ac"
import script from "./ModalAlert.vue?vue&type=script&lang=js"
export * from "./ModalAlert.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__